export default __webpack_public_path__ + "static/media/team-1.cf2dcd32.jpg";